import { theme } from '@frontend/theme';

interface Props {
  size?: 'small' | 'medium' | 'large';
  color: string;
}

const SIZE_MAP = {
  small: 12,
  medium: 16,
  large: 20,
  xLarge: 40,
};

export const ColorDot = ({ color, size = 'medium' }: Props) => {
  return (
    <span
      css={{
        display: 'inline-block',
        backgroundColor: color,
        borderRadius: theme.borderRadius.full,
        width: size ? SIZE_MAP[size] : SIZE_MAP.medium,
        height: size ? SIZE_MAP[size] : SIZE_MAP.medium,
        flexShrink: 0,
      }}
    ></span>
  );
};
